import { forkJoin, from, Observable } from 'rxjs';
import { concatMap } from 'rxjs/operators';

export const chunked = (httpCalls: Observable<unknown>[]): Observable<unknown> => {
  const chunkSize = 5;
  const chunkedCalls = [];
  let index = 0;
  while (index < httpCalls.length) {
    chunkedCalls.push(httpCalls.slice(index, chunkSize + index));
    index += chunkSize;
  }

  return from(chunkedCalls).pipe(concatMap((chunk) => forkJoin(chunk)));
};
